import { CheckIcon } from "@heroicons/react/24/outline";

type ScopeOptionRowProps = {
    label: string;
    hint?: string;
    isSelected: boolean;
    onSelect: () => void;
};

export function ScopeOptionRow({ label, hint, isSelected, onSelect }: ScopeOptionRowProps) {
    return (
        <button
            type="button"
            onClick={onSelect}
            className="flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50"
        >
            <span className="min-w-0 flex-1 truncate">
                {label}
                {hint && <span className="ml-1.5 text-[10px] text-gray-400">{hint}</span>}
            </span>
            {isSelected && <CheckIcon className="h-3.5 w-3.5 shrink-0 text-primary" />}
        </button>
    );
}
